import {PencilIcon} from '@time-webkit/all/icons/pencil';

import {TrashDeleteIcon} from '@time-webkit/all/icons/trash-delete';

import {ActionButton} from '@time-webkit/all/molecules/icon-button';

import styles from './styles.module.css';

interface Props {
    handleRemoveClick: () => void;
    handleEditClick: () => void;
}

export const Actions: React.FC<Props> = (props) => {
    return (<div className={styles.actions}>
        <ActionButton
            className={styles.action}
            onPress={props.handleEditClick}
        >
            <PencilIcon
                className={styles.action_icon}
                width={16}
                height={16}
            />
        </ActionButton>
        <ActionButton
            className={styles.action}
            onPress={props.handleRemoveClick}
        >
            <TrashDeleteIcon
                className={styles.action_icon}
                width={16}
                height={16}
            />
        </ActionButton>
    </div>);
};
